import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import 'typeface-open-sans';

import { createStore } from "redux";
import { Provider } from "react-redux";
import { rootReducer } from "./redux";

if (process.env.NODE_ENV !== 'development') {
	// silence console.log calls in production
	console.log = () => {}
}

const store = createStore(rootReducer);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<App />
	</Provider>
);